<div class="d-flex justify-content-center">
    <button
        type="button"
        class="btn btn--table-action d-flex align-items-center justify-content-center p-0 m-0 waves-effect waves-light "
        placement="bottom"
        [mdbPopover]="content"
        (popoverShown)="onPopoverShown()"
        (popoverHidden)="onPopoverHidden()"
        trigger="click"
        #popover="mdbPopover"
    >
        <i class="black-text fas fa-ellipsis-h mt-0" style="font-size:0.81rem"></i>
    </button>
</div>

<ng-template #content>
  <div class="popover-links popover-links--aligned">
    <div
        *ngIf="status === 'Pending'"
        class="popover__action body-1 d-flex align-items-center cursor-pointer px-4 py-1"
        (click)="resend()"
        style="line-height: 24px !important;"
    >
        <i class="black-text fas fa-sync mt-0 mr-2"></i>
        <div>Resend</div>
    </div>
    <div
        class="popover__action body-1 d-flex align-items-center cursor-pointer px-4 py-1"
        (click)="deleteUser()"
        style="line-height: 24px !important;"
    >
        <i class="black-text far fa-trash-alt mt-0 mr-2"></i>
        <div>Delete</div>
    </div>
  </div>
</ng-template>
